import { useQuery, useQueryClient } from "@tanstack/react-query";
import classNames from "classnames";
import LabelledDivRow from "components/LabelledDivRow";
import { Loading } from "components/panels";
import React from "react";

const VatNumberRows = () => {
  const healthQuery = useQuery({
    queryFn: async () => window.CoreApi.EuVatNumber.CompanyVatNumberHealth().then(r => r.data),
    queryKey: ["vatCodeHealth"]
  });

  const queryClient = useQueryClient();

  const onRefresh = async () => queryClient.invalidateQueries(["vatCodeHealth"]);

  if (healthQuery.isError || healthQuery.data?.hasErrors) return <div>Error loading vat code health</div>;
  if (healthQuery.isFetching) return <Loading />;

  const { lookupPending, lookupPendingKey, webServiceError, webServiceErrorKey, formattingError, formattingErrorKey } = healthQuery.data.data;
  const getKey = (key: number) => `key: ${key}`;
  return <>
    <LabelledDivRow label="Lookup pending" title={getKey(lookupPendingKey)}>
      <div className={classNames({ red: lookupPending > 10 })}>{lookupPending}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Web service error" title={getKey(webServiceErrorKey)}>
      <div className="red">{webServiceError}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Formatting error" title={getKey(formattingErrorKey)}>
      <div className="red">{formattingError}</div>
    </LabelledDivRow>
    <LabelledDivRow label="">
      <a onClick={onRefresh}>Refresh</a>
    </LabelledDivRow>
  </>;
};

export default VatNumberRows;